import React, { useState, useEffect, useCallback } from "react";

// react meta tags
import MetaTags, { ReactTitle } from 'react-meta-tags';

// react redux
import { connect } from "react-redux";

// APIs
import {
    getProductDetails,
    cancelGetProductDetailsApi,
    getVariationDetails,
    cancelGetVariationDetailsApi,
    getCombinationDetails,
    cancelGetCombinationDetailsApi
} from "utlis/Apis/Products_API";

// custom hooks
import useQueryHook from 'utlis/CustomHooks/useQueryHook';

// react toastify
import { toast } from "react-toastify";

// API | cart
import { saveToCart } from "utlis/Apis/Cart_API";

// actions
import { setCartDetails, setCartImages, setCartItem } from "redux/actions/actionCart";

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
    ADDED_TO_CART_SUCCESSFULLY,
    ERROR_WHILE_SAVING_PRODUCT_TO_CART,
} from "utlis/AppMessages/AppMessages";

// themes
import { Theme1 } from "./themes";

function ProductDetail(props) {
    // props
    const {
        globalAppTheme,
        match,
        currentUser,

        setCartItem,
        setCartImages,
        setCartDetails,

        tempOrderId,
    } = props

    // consts
    const query = useQueryHook()

    // states
    const [currentRoute, setCurrentRoute] = useState({}); // { routeName: 'name of the route', routeUrl: 'url of the route' }

    const [productId, setProductId] = useState(null);
    const [productsDetailsLoading, setProductsDetailsLoading] = useState(false);
    const [productDetails, setProductDetails] = useState([]);
    const [productDetailsCombinationWise, setProductDetailsCombinationWise] = useState(null);
    const [combinationNotAvailable, setCombinationNotAvailable] = useState(false);
    const [variantMainFields, setVariantMainFields] = useState([]);
    const [productCombinations, setProductCombinations] = useState([]);
    const [productCombinationsImages, setProductCombinationsImages] = useState([]);
    const [selectedOptionsByUser, setSelectedOptionsByUser] = useState([]);
    const [selectedOptionsByUserString, setSelectedOptionsByUserString] = useState("");

    const [buttonLoading, setButtonLoading] = useState(false);
    const [availableCombinations, setAvailableCombinations] = useState([]);

    const [allowedVariantsValues, setAllowedVariantsValues] = useState([]);

    const [selectedValue, setSelectedValue] = useState({});

    const [productQuantity, setProductQuantity] = useState("1")

    // setting product id
    useEffect(() => {
        const prodId = query.get('id')
        if (prodId) {
            // setting product id
            setProductId(prodId)
        }
    }, [query])

    // function to get categories
    const getProduct = useCallback(() => {
        if (productId) {
            // enabling loading
            setProductsDetailsLoading(true);

            // getting data
            Promise.all([
                getProductDetails(currentUser?.userToken ?? "", productId),
                getVariationDetails(currentUser?.userToken ?? "", productId),
                getCombinationDetails(currentUser?.userToken ?? "", productId),
            ]).then((res) => {
                // managing product details
                (function () {
                    const prodData = res[0].data;

                    // if request is success
                    if (prodData.success) {
                        setProductDetails(prodData.data);
                    }
                })();

                // managing variation details
                (function () {
                    const variationData = res[1].data;

                    // if request is success
                    if (variationData.success) {
                        let generatedVariantArray = [];
                        variationData?.data?.forEach((item) => {
                            generatedVariantArray.push({
                                display_type: item.display_type,
                                id: item.variation_id,
                                options: JSON.parse(item.options),
                                variation_name: item.variation_name,
                            });
                        });
                        // console.log("generatedVariantArray variationData ", generatedVariantArray)
                        // setting main variant section
                        setVariantMainFields(generatedVariantArray);
                    }
                })();

                // managing product variations data
                (function () {
                    const combinationsData = res[2].data;

                    // if request is success
                    if (combinationsData.success) {
                        setProductCombinations(combinationsData.data);

                        // combinations iamges
                        setProductCombinationsImages(combinationsData.images)
                    }

                    // if request is error
                    if (combinationsData.error) {
                        console.log("combinationsData error ", combinationsData);
                    }
                })();

                // disabling loading
                setProductsDetailsLoading(false);
            }).catch((err) => {
                console.log(`${ERROR_WHILE__NAME} getProductDetails `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling loading
                        setProductsDetailsLoading(false);
                    },
                });
            });
        }
    }, [currentUser, productId]);

    // getting products
    useEffect(() => {
        // calling products and variations getter function
        getProduct();

        return () => {
            // canceling get products api when user leaves the component
            cancelGetProductDetailsApi && cancelGetProductDetailsApi();

            // canceling get variations api when user leaves the component
            cancelGetVariationDetailsApi && cancelGetVariationDetailsApi();

            // canceling get combinations api when user leaves the component
            cancelGetCombinationDetailsApi && cancelGetCombinationDetailsApi();
        };
    }, [getProduct]);

    // breadcrumbs generating
    useEffect(() => {
        if (match?.params?.prodName) {
            const prodName = match?.params?.prodName

            // setting current route
            setCurrentRoute({
                routeName: prodName,
                sku: prodName,
                routeUrl: "/shop/" + prodName + "?id=" + productId,
            });
        }
    }, [match, productId]);

    // function to generate class name as per requirements
    const generatingClass = data => {
        if (data) {
            const value = data.replaceAll(" ", "").toLowerCase() // removing spaces and lowercasing
            return value
        }
        return ""
    }

    // generating array for available combination options
    useEffect(() => {
        let mainObj = {}
        variantMainFields.forEach(variItem => {
            variItem?.options.forEach(variOptItem => {
                const id = generatingClass(variOptItem.option_variation_name) + "-" + variOptItem.id
                // console.log("id ", id);
                mainObj[id] = [];
                // console.log("mainObj ", mainObj);
                productCombinations.forEach(combiItem => {
                    if (combiItem?.variation_combination) {
                        const newArr = []
                        let newArr2 = []
                        const mainCombiData = JSON.parse(combiItem.variation_combination)
                        if (mainCombiData?.length) {
                            mainCombiData.forEach(item => {
                                newArr.push(generatingClass(item.option_variation_name) + "-" + item.id)
                            })
                        }
                        newArr2 = newArr.filter(item => item !== id);
                        if (newArr2.length !== newArr.length) {
                            if (mainObj[id][0]) {
                                mainObj[id] = [...mainObj[id], ...newArr2];
                            } else {
                                mainObj[id] = newArr2
                            }
                        }

                    }
                })
            })
        })
        // setting data
        setAvailableCombinations(mainObj)
    }, [variantMainFields, productCombinations])

    // getting the variation options selected by the user
    const generateValues = () => {
        const values = document.querySelectorAll('.rectangles-list [type="radio"]:checked')

        let idsOnly = []
        const allValues = []
        if (values.length) {
            values.forEach(item => {
                allValues.push(item.parentElement.getAttribute('data-id'))
            })
        }

        if (allValues?.length) {
            allValues.forEach(item => {
                const splittedData = item.search("-") !== -1 ? item.split("-") : "" // if the values has (-) in it
                if (splittedData?.length) {
                    const newData = splittedData.find((item, index) => index !== 0 && item) // removing only the first item from the array
                    // pushing the changes
                    idsOnly.push(newData)
                }
            })
        }

        // setting selected values
        setSelectedOptionsByUserString(idsOnly.toString().replace(/,/g, "-"))
    }

    // getting the selected variation option when user selects any
    useEffect(() => {
        if (selectedOptionsByUserString?.length) {
            let foundCombination = {}
            productCombinations.forEach(item => {
                if (item.ids === selectedOptionsByUserString) {
                    foundCombination = item
                }
            })

            if (Object.keys(foundCombination)?.length) {
                // console.log("combination found");
                setProductDetailsCombinationWise(foundCombination)
                setCombinationNotAvailable(false)
            } else {
                // console.log("combination not found");
                setProductDetailsCombinationWise({})
                setCombinationNotAvailable(true)
            }
        }
    }, [selectedOptionsByUserString, productCombinations])


    // add to cart button hadling
    const handleAddToCartButtonClick = (ev, selectedProduct) => {
        ev.preventDefault();
        // enabling button loading
        setButtonLoading(true);

        (function () {
            const cartItemToSave = {
                customer_id: currentUser?.userId ?? "",
                mode: "new",
                product_id: selectedProduct.product_id,
                quantity: parseInt(productQuantity),
                temp_order_id: tempOrderId,
                variant_sku: productDetailsCombinationWise?.sku ?? "",
            };

            // console.log("cartItemToSave ", cartItemToSave);

            // getting data
            saveToCart(currentUser?.userToken, cartItemToSave).then((res) => {
                // console.log("resData from saveToCart ", res);
                const resData = res.data;

                // disabling button loading
                setButtonLoading(false);

                // if request succesfull
                if (resData && resData.success) {
                    const cartData = resData.data;

                    // saving items to global store
                    setCartItem(cartData.content);
                    setCartImages(cartData.images);
                    setCartDetails({
                        cart_discount: cartData.cart_discount,
                        cart_items: cartData.cart_items,
                        cart_qty: cartData.cart_qty,
                        cart_sub_total: cartData.cart_sub_total,
                        cart_total: cartData.cart_total,
                        coupon_code: cartData.coupon_code,
                        coupon_value: cartData.coupon_value,
                        allCartData: cartData
                    });

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(ADDED_TO_CART_SUCCESSFULLY, {
                        autoClose: 3000,
                        onClose: () => { },
                    });
                }

                // if request is not succesfull
                if (resData && resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message || ERROR_WHILE_SAVING_PRODUCT_TO_CART, {
                        autoClose: 3000,
                        onClose: () => { },
                    });
                }
            }).catch((err) => {
                console.log(`${ERROR_WHILE__NAME} saveToCart `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 3000,
                    onClose: () => {
                        // disabling button loading
                        setButtonLoading(false);
                    },
                });
            });
        })();
    };

    return (
        <React.Fragment>
            {
                !productsDetailsLoading ? (
                    <ReactTitle title={productDetailsCombinationWise?.product_name ?? productDetails?.product_name} />
                ) : (
                    <ReactTitle title="krave | Product Details" />
                )
            }

            {
                globalAppTheme === 'theme1' ? (
                    <Theme1
                        availableCombinations={availableCombinations}

                        allowedVariantsValues={allowedVariantsValues}
                        setAllowedVariantsValues={setAllowedVariantsValues}

                        currentRoute={currentRoute}

                        productsDetailsLoading={productsDetailsLoading}
                        productDetails={productDetails}

                        productDetailsCombinationWise={productDetailsCombinationWise}
                        combinationNotAvailable={combinationNotAvailable}

                        variantMainFields={variantMainFields}
                        productCombinations={productCombinations}
                        productCombinationsImages={productCombinationsImages}

                        selectedOptionsByUser={selectedOptionsByUser}
                        setSelectedOptionsByUser={setSelectedOptionsByUser}

                        buttonLoading={buttonLoading}
                        handleAddToCartButtonClick={(ev, selectedProduct) => handleAddToCartButtonClick(ev, selectedProduct)}

                        generateValues={generateValues}

                        selectedValue={selectedValue}
                        setSelectedValue={setSelectedValue}

                        productQuantity={productQuantity}
                        setProductQuantity={setProductQuantity}
                    />
                ) : null
            }
        </React.Fragment>
    )
}

const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
        currentUser: state.auth.currentUser,
        tempOrderId: state.auth.tempOrderId,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setCartDetails: cartDetails => dispatch(setCartDetails(cartDetails)),
        setCartItem: cartData => dispatch(setCartItem(cartData)),
        setCartImages: cartData => dispatch(setCartImages(cartData)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(ProductDetail);
